import i18n from 'src/i18n';

const configTable = () => {
    const tableColumns = [
        {
            prop: 'name',
            label: i18n.t('common_words.name'),
            minWidth: 150,
            sortable: true,
        },
    ];
    
    return { tableColumns };
}
export default configTable;